jQuery(function($) {
    $productSwiper = new Swiper(".product-group-slider__slider", {
        slidesPerView: 3,
        spaceBetween: 30,
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 5000,
        },
        pagination: {
            el: ".swiper-pagination.product",
            type: "fraction",
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          780: {
            slidesPerView: 3,
          },
          0: {
            slidesPerView: "auto",
          }
        }
    });
    $testimonialSwiper = new Swiper(".testimonial-block__block-slider", {
      slidesPerView: "auto",
      spaceBetween: 30,
      centeredSlides: false,
      autoplay: {
        delay: 4000,
      },
      pagination: {
          el: ".swiper-pagination.testimonial",
          type: "fraction",
      },
      navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
      },
      // breakpoints: {
      //   0: {
      //     slidesPerView: 1,
      //     centeredSlides: true,
      //   }
      // }
  });

    $(document).ready(function() {
      // ADD CURENT MENU ITEM TO LI IN MENU ON CPT SINGLE PAGE
      if (window.location.href.indexOf("products") > -1) {
        $("li a[href*='products']").parent().addClass('current-menu-item');
      }
      // MOBILE MENU
      $('.hamburger-menu').on('click', function(e) {
          e.preventDefault();
          $('.header__mobile-submenu').toggleClass('active');
          $('html').toggleClass('no-scroll');
          $('.overlay').toggleClass('active');
          return false;
      });

      // ADD CLASS TO PRODUCT PRO/CON IF EMPTY
        $('.product li').each(function() {
          if ($(this).is(':empty')) {
            $(this).addClass('empty');
          }
        });

        // CHANGE HEADER BG COLOR AFTER SCROLL
        function changeHeaderBg(){
          $scrollDistance = $(document).scrollTop();
          if ($scrollDistance > window.innerHeight * 0.1) {
            $('header').addClass('scrolled');
          } else {
            $('header').removeClass('scrolled');
          }
        }
        changeHeaderBg();

        $(document).scroll(function() {
            changeHeaderBg();
        });

        // LOAD MORE POSTS & CREATE LAYOUT
        // $postsPerPage = 3;
        // $currentPage = 1;
        // $('.posts-container .post').slice(6).hide();

        // if ($('.posts-container .post').length <= $postsPerPage) {
        //   $('.load-more').hide();
        // }
        // $('.load-more').click(function(e){
        //     e.preventDefault();
        //     $('.posts-container .post').slice($currentPage * $postsPerPage, ($currentPage + 1) * $postsPerPage).fadeIn();
           
        //     $currentPage++;
    
        //     if ($('.posts-container .post').length <= $currentPage * $postsPerPage) {
        //         $('.load-more').hide();
        //     }
        // });
        $postsPerPage = 3;
        $currentPage = 1;
        $defaultPage = $('.posts-container').data('default');
        $('.posts-container .post').slice($defaultPage).hide();
      
        if ($('.posts-container .post').length <= $postsPerPage) {
          $('.load-more').hide();
        }
      
        $('.load-more').click(function(e) {
          e.preventDefault();
      
          $('.posts-container .post:hidden').slice(0, $postsPerPage).fadeIn();
      
          if ($('.posts-container .post:hidden').length === 0) {
            $('.load-more').hide();
            $('.load-all').css('display', 'block');
          }
        });
        $itemsPerRow = 3;
        $rows = Math.ceil($('.post').length / $itemsPerRow);
        for (var i = 0; i < $rows; i++) {
            $rowIndex = i + 1;
            if ($rowIndex % 2 === 1) {
                $('.post:nth-child(' + (i * $itemsPerRow + 1) + ')').addClass('wide');
            } else {
                $('.post:nth-child(' + (i * $itemsPerRow + $itemsPerRow) + ')').addClass('wide');
            }
        }

        $originalParentBrochure = '';
        $originalParentVideo = '';
        // DISPLAY OVERLAY ON CLICK AND LOAD CORRECT CONTENT
        $(".video").click(function(e) {
          e.preventDefault();
          $originalParentVideo = $(this).closest('.product-wrapper');
          $targetVideo = $originalParentVideo.parent('.single-page__right');
          $(".overlay").addClass("active");
          $originalParentVideo.find(".overlay__video").addClass("active");
          $originalParentVideo.find(".overlay__video").appendTo($targetVideo);
          // $(".overlay__video").addClass("active");
          $("html, body").addClass("no-scroll");
          // $("html").css("height", "100%");
          return false;
        });
        $(".brochure").click(function(e) {
          e.preventDefault();
          $originalParentBrochure = $(this).closest('.product-wrapper');
          $targetBrochure = $originalParentBrochure.parent('.single-page__right');
          $(".overlay").addClass("active");
          $originalParentBrochure.find(".overlay__brochure").addClass("active");
          $originalParentBrochure.find(".overlay__brochure").appendTo($targetBrochure);
          // $(".overlay__brochure").addClass("active");
          $("html, body").addClass("no-scroll");
          // $("html").css("height", "100%");
          return false;
        });
        $(".request-quote").click(function(e) {
          e.preventDefault();
          $(".overlay").addClass("active");
          $(".overlay__quote").addClass("active");
          $("html, body").addClass("no-scroll");
          // $("html").css("height", "100%");
          if ($(window).width() > 1024) {
            $rightChildHeight = $('.form__right').outerHeight();
            $('.gform_fields').css('height', $rightChildHeight);
         }
          return false;
        });
        $(".close").click(function(e) {
          e.preventDefault();
          $(".overlay").removeClass("active");
          $(".overlay-quote").removeClass("active");
          $(".overlay__video").removeClass("active");
          $(".overlay__brochure").removeClass("active");
          $(".overlay__quote").removeClass("active");
          $("html, body").removeClass("no-scroll");
          $(this).closest(".overlay__video").appendTo($originalParentVideo);
          $(this).closest(".overlay__brochure").appendTo($originalParentBrochure);
          // $("html").css("height", "");
          return false;
        });

        // MOVE NUMBER FIELDS IN FORM TO LEFT COLUMN
        $('.overlay__quote .dynamic-field').wrapAll('<div class="form__left"></div>');
        $('.overlay__quote .gfield:not(.dynamic-field), .gform_button').wrapAll('<div class="form__right"></div>');
        $('.overlay__quote .form__left-content').prependTo('.form__left');
        $('.overlay__quote .form__left-content .button').appendTo('.form__left');
        $('.overlay__quote .form__right-content').prependTo('.form__right');

        $('.gform_button').addClass('button yellow big');
        
        $(".form__left .form-button").click(function(e) {
          e.preventDefault();
          $(".gform_fields").scrollTop(0);
          $(".form__left").addClass("not-active");
          $(".form__right").addClass("active");
          return false;
        });

        $(".form__right .form-button").click(function(e) {
          e.preventDefault();
          $(".gform_fields").scrollTop(0);
          $(".form__left").removeClass("not-active");
          $(".form__right").removeClass("active");
          return false;
        });

        // ADD SCROLL REVEAL ANIMATIONS
        ScrollReveal().reveal('.reveal-first', { delay: 200, distance: '50px' });
        ScrollReveal().reveal('.reveal-second', { delay: 500, distance: '50px' });

        // FIX BUTTON IN MENU FOR UNDERLINE EFFECT
        $buttonMenuItems = $('li.small');
        $buttonMenuItems.find('span.button.underline').replaceWith(function() {
          return $(this).text();
        });

        // READ MORE
        function readMore() {
          $(".product__left p").each(function() {
            if ($(this).height() > 89 && $(window).width() > 767) {
              if ($(this).parent().find('.more-btn').length === 0) {
                $(this).parent().append("<div class='more-btn'>Show more</div>");
              }
              $(this).addClass("more");
            } else if ($(this).height() > 159 && $(window).width() < 767) {
              if ($(this).parent().find('.more-btn').length === 0) {
                $(this).parent().append("<div class='more-btn'>Show more</div>");
              }
              $(this).addClass("more");
            } else {
              $(this).parent().find('.more-btn').remove();
              $(this).removeClass("more");
            }
          });
        }
      readMore();

      $(window).resize(function() {
        readMore();
      });
    
      $( ".more-btn" ).click(function() {
        $(this).parent().toggleClass("opened");
        $(this).toggleClass("opened");
        $(this).text(function(i, text){
                return text === "Show more" ? "Show less" : "Show more";
            })
      });
    });

    // DISABLE SUBMIT BUTTON BEFORE ALL REQUIRED FIELDS ARE FILLED IN
    $('form[id^="gform_"]').on('change', function (e) {
        $reqd = $(this).find('.gfield_contains_required.gfield_visibility_visible').filter(function (i, c) {
            $inputs = $(c).find('input, textarea, select');
            $requiredInputs = $inputs.filter('[aria-required="true"]');
            return $requiredInputs.filter(function () { return $(this).val().length === 0; }).length;
        });
        if ($reqd.length) {
            $(this).find('input[type="submit"]').addClass('disabled button-disabled').attr('disabled', 'disabled');
        } else {
            $(this).find('input[type="submit"]').removeClass('disabled button-disabled').removeAttr('disabled');
        }
    }).trigger('change');
  
    //PAGINATION
    $targetElements = $('.next-page a, .previous-page a');
    $parentElements = $('.next-page, .previous-page');
  
    $targetElements.each(function() {
      $targetElement = $(this);
      $parentElement = $targetElement.closest('.next-page, .previous-page');
  
      if ($targetElement.is(':visible')) {
        $parentElement.addClass('no-after');
      }
    });
});  